/* eslint-disable import/no-webpack-loader-syntax,import/no-unresolved */

import { MAP_DEFAULT_OPTIONS, PARALLEL_LENGTH_PERCISION } from 'settings/constants/map'
import { WORK_ORDER_STATUS, WORK_ORDER_STATUS_DISPLAY } from 'settings/constants/service'
import { toast } from 'react-toastify'
import { get } from 'utils/lodash'
import { stopStatus } from 'utils/workOrderStatus'
import Constants from 'Constants'
import T from 'T'
import ReactDOM from 'react-dom'
import { common } from '@mui/material/colors'
import { isEmpty } from 'lodash'
import mapboxgl from '!mapbox-gl'

const { MEDIA_SERVER } = Constants
const { MAP_VIEW_URL, LIGHT_VIEW, LNG_LAT_FIX, ZOOM_FIX, PROJECTION } = MAP_DEFAULT_OPTIONS
const { SERVICED, SKIPPED } = WORK_ORDER_STATUS

// Add conditions to check if mapContainer, map, marker references exist then only call these methods

const CREATE_MAP_MAX_TRY = 3
const MAX_ONE_DIGIT_ALLOWED = 9
const MAX_TWO_DIGIT_ALLOWED = 99
const RADIUS_OF_EARTH = 6371 // radius of earth in km
const EARTH_DIAMETER = 12742 // diameter of the earth expressed in km
const DEGREE_TO_RADIAN = 0.017453292519943295 // an angle expressed in degrees to radians
let mapTryCount = 0

export const isMapboxSupported = mapboxgl => {
  try {
    if (!mapboxgl.supported()) {
      toast.error(T.BROWSER_NOT_SUPPORT_MAPBOX)
    }
  } catch (err) { }
}

export const createMap = (mapboxgl, mapContainer, lng, lat, zoom, mapStyle = LIGHT_VIEW, callback = null) => {
  try {
    const map = new mapboxgl.Map({
      // renderWorldCopies: false,
      container: mapContainer.current,
      style: MAP_VIEW_URL + mapStyle,
      center: [lng, lat],
      zoom,
      projection: PROJECTION,
    })

    // reset try count
    mapTryCount = 0

    return callback ? callback(map) : map
  } catch (err) {
    if (mapTryCount < CREATE_MAP_MAX_TRY) {
      mapTryCount += 1
      setTimeout(() => {
        createMap(mapboxgl, mapContainer, lng, lat, zoom, mapStyle, callback)
      }, 15)
    } else {
      // reset try count
      mapTryCount = 0
      toast.error(`${get(err, 'message', err)} | Please try to refresh/restart your browser`)

      return callback ? callback(null) : null
    }
  }
}

export const createMarker = (mapboxgl, map, lng, lat) => {
  try {
    return new mapboxgl.Marker({
      draggable: true,
      color: '#da0808',
    })
      .setLngLat([lng, lat])
      .addTo(map.current)
  } catch (err) {
    toast.error(`${get(err, 'message', err)}`)
    return null
  }
}

const getsequenceLength = routeSequence => {
  if (routeSequence > MAX_TWO_DIGIT_ALLOWED) {
    return -3
  }
  return routeSequence > MAX_ONE_DIGIT_ALLOWED ? 0 : 2.5
}

const getMarkerLogo = (routeSequence, color, sequenceLength) => {
  return `<svg display="block" height="60px" width="38px" viewBox="0 0 27 41 "transform="translate(0, -20)"><g fill-rule="nonzero"><g transform="translate(3.0, 29.0)" fill="#000000"><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="9.5" ry="4.77275007"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="8.5" ry="4.29549936"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="7.5" ry="3.81822308"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="6.5" ry="3.34094679"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="5.5" ry="2.86367051"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="4.5" ry="2.38636864"></ellipse></g><g fill="${color}"><path d="M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"></path></g><g opacity="0.25" fill="#000000"><path d="M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"></path></g><g transform="translate(6.0, 7.0)" fill="#FFFFFF"></g><g transform="translate(8.0, 8.0)"><circle fill="#FFFFFF" cx="5.5" cy="5.5" r="11"></circle><text translate(-2,5) transform="translate(${sequenceLength},5)" dominant-baseline="central" cy="5.5" cx="5.5" font-size="10px">${routeSequence}</text></g></g></svg>`
}

const getMarkerIcon = (iconType, color, sequenceLength = 0, routeSequence = 0) => {
  switch (iconType) {
    case SERVICED:
      return `<svg display="block" height="60px" width="38px" viewBox="0 0 27 41 "transform="translate(0, -20)"><g fill-rule="nonzero"><g transform="translate(3.0, 29.0)" fill="#000000"><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="9.5" ry="4.77275007"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="8.5" ry="4.29549936"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="7.5" ry="3.81822308"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="6.5" ry="3.34094679"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="5.5" ry="2.86367051"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="4.5" ry="2.38636864"></ellipse></g><g fill="${color}"><path d="M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"></path></g><g opacity="0.25" fill="#000000"><path d="M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"></path></g><g transform="translate(6.0, 7.0)" fill="#FFFFFF"></g><g transform="translate(7.0, 7.0)"><image width="14" height="14" translate(-2,5)="" transform="translate(-0, -1)" dominant-baseline="" cy="5.5" cx="5.5" xlink:href=${MEDIA_SERVER}Tick-White.png></image></g></g></svg>`
    case SKIPPED:
      return `<svg display="block" height="60px" width="38px" viewBox="0 0 27 41 "transform="translate(0, -20)"><g fill-rule="nonzero"><g transform="translate(3.0, 29.0)" fill="#000000"><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="9.5" ry="4.77275007"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="8.5" ry="4.29549936"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="7.5" ry="3.81822308"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="6.5" ry="3.34094679"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="5.5" ry="2.86367051"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="4.5" ry="2.38636864"></ellipse></g><g fill="#4F566B"><path d="M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"></path></g><g opacity="0.25" fill="#000000"><path d="M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"></path></g><g transform="translate(6.0, 7.0)" fill="#FFFFFF"></g><g transform="translate(8.0, 8.0)"><circle fill="#FFFFFF" cx="5.5" cy="5.5" r="11"></circle><text translate(-2,5) transform="translate(${sequenceLength},5)" dominant-baseline="central" cy="5.5" cx="5.5" font-size="10px">${routeSequence}</text></g></g></svg>`
    case 'startpoint':
      return `<svg display="block" height="60px" width="38px" viewBox="0 0 27 41 "transform="translate(0, -20)"><g fill-rule="nonzero"><g transform="translate(3.0, 29.0)" fill="#000000"><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="9.5" ry="4.77275007"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="8.5" ry="4.29549936"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="7.5" ry="3.81822308"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="6.5" ry="3.34094679"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="5.5" ry="2.86367051"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="4.5" ry="2.38636864"></ellipse></g><g fill="${color}"><path d="M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"></path></g><g opacity="0.25" fill="#000000"><path d="M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"></path></g><g transform="translate(6.0, 7.0)" fill="#FFFFFF"></g><g transform="translate(8.0, 8.0)"><circle fill="#FFFFFF" cx="5.5" cy="5.5" r="11"></circle><image width="11" height="11" translate(-2,5)="" transform="translate(-0, -1)" dominant-baseline="" cy="5.5" cx="5.5" xlink:href=${MEDIA_SERVER}GarageOpen.png></image></g></g></svg>`
    case 'endpoint':
      return `<svg display="block" height="60px" width="38px" viewBox="0 0 27 41 "transform="translate(0, -20)"><g fill-rule="nonzero"><g transform="translate(3.0, 29.0)" fill="#000000"><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="9.5" ry="4.77275007"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="8.5" ry="4.29549936"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="7.5" ry="3.81822308"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="6.5" ry="3.34094679"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="5.5" ry="2.86367051"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="4.5" ry="2.38636864"></ellipse></g><g fill="${color}"><path d="M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"></path></g><g opacity="0.25" fill="#000000"><path d="M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"></path></g><g transform="translate(6.0, 7.0)" fill="#FFFFFF"></g><g transform="translate(8.0, 8.0)"><circle fill="#FFFFFF" cx="5.5" cy="5.5" r="11"></circle><image width="11" height="11" translate(-2,5)="" transform="translate(-0, -1)" dominant-baseline="" cy="5.5" cx="5.5" xlink:href=${MEDIA_SERVER}GarageOpen.png></image></g></g></svg>`
    default:
      return ''
  }
}

const MapPopup = ({ icon, measureVolume }) => {
  return (
    <div className="flex">
      <span>{measureVolume}</span>
      {icon && <img className="pl1" src={icon} />}
    </div>
  )
}

export const createMultipleMarker = (mapboxgl, map, toggleMarkerDetailDrawer, data) => {
  const routeCord = get(data, 'cord', null)
  if (routeCord) {
    const color = get(data, 'color', '#888')
    const routeID = get(data, 'routeID', '')
    const icon = get(data, 'icon', null)
    const workOrderStatus = get(data, 'workOrderStatus', null)
    const el = document.createElement('div')
    const routeSequence = get(data, 'routeSequence', 0)
    const sequenceLength = getsequenceLength(routeSequence)
    const popupInfo = get(data, 'popupInfo', null)
    const measureVolume = get(data, 'popupInfo.measureVolume', '')
    const actionIcon = get(data, 'popupInfo.actionIcon', '')

    if ([SERVICED, SKIPPED].includes(workOrderStatus)) {
      el.innerHTML = getMarkerIcon(workOrderStatus, color, sequenceLength, routeSequence)
      el.addEventListener('click', e => {
        toggleMarkerDetailDrawer(e, routeID, routeSequence)
      })
    } else if (icon) {
      el.innerHTML = getMarkerIcon(icon, color, sequenceLength, routeSequence)
    } else {
      el.innerHTML = getMarkerLogo(routeSequence, color, sequenceLength)
      el.addEventListener('click', e => {
        toggleMarkerDetailDrawer(e, routeID, routeSequence)
      })
    }

    const popupNode = document.createElement('div')
    ReactDOM.render(<MapPopup icon={actionIcon} measureVolume={measureVolume} />, popupNode)

    const popup = new mapboxgl.Popup({
      offset: 45,
      closeOnClick: false,
      closeButton: false,
    }).setDOMContent(popupNode)

    try {
      if (popupInfo) {
        return new mapboxgl.Marker(el).setLngLat(routeCord).setPopup(popup).addTo(map.current)
      }
      return new mapboxgl.Marker(el).setLngLat(routeCord).addTo(map.current)
    } catch (err) {
      toast.error(`${get(err, 'message', err)}`)
      return null
    }
  }
}
export const addMapLayer = (map, routeId, color, geojson) => {
  return map.current.on('load', function () {
    map.current.addLayer({
      id: routeId,
      type: 'line',
      source: {
        type: 'geojson',
        data: geojson,
      },
      layout: {
        'line-join': 'round',
        'line-cap': 'round',
      },
      paint: {
        'line-color': color || '#888',
        'line-width': 2,
        'line-dasharray': [1, 2],
      },
    })
  })
}
export const dragEndMarkerResult = (map, marker) => ({
  isMapChanged: true,
  mapLng: marker.getLngLat().lng.toFixed(LNG_LAT_FIX),
  mapLat: marker.getLngLat().lat.toFixed(LNG_LAT_FIX),
  mapZoom: map.current.getZoom().toFixed(ZOOM_FIX),
})

export const dragEndMarkerFullResult = (map, marker) => ({
  isMapChanged: true,
  mapLng: marker.getLngLat().lng,
  mapLat: marker.getLngLat().lat,
  mapZoom: map.current.getZoom().toFixed(ZOOM_FIX),
})

export const flyToMap = (map, lng, lat, zoom, essential = true) =>
  map.current.flyTo({ center: [lng, lat], essential, ...(zoom && { zoom }) })

export const easeToMap = (map, lng, lat) => map.current.easeTo({ center: [lng, lat] })

/**
 * Best fit for map view
 */

// get parallel length for centroid lat
export const getParallelLength = atLatitude => {
  const fromLAT = 0
  const toLAT = 1
  const parallelLen = 2
  const parllelLengthPercision = PARALLEL_LENGTH_PERCISION
  for (let pLength = 0; pLength < parllelLengthPercision.length; pLength++) {
    const fromLat = parllelLengthPercision[pLength][fromLAT]
    const toLat = parllelLengthPercision[pLength][toLAT]
    const atLat = atLatitude
    if (fromLat <= atLat && atLat < toLat) {
      return parllelLengthPercision[pLength][parallelLen]
    }
  }
  return 0
}

// get furthest coordinates from center point
export const findFurthestLatLong = (centerCoordinates, coordinatesArray) => {
  const dataObject = {}
  for (let coordinate = 0; coordinate < coordinatesArray.length; coordinate++) {
    // haversine calculations to get farthest lat longs
    const hav =
      0.5 -
      Math.cos((parseFloat(coordinatesArray[coordinate][1]) - centerCoordinates.lat) * DEGREE_TO_RADIAN) / 2 +
      (Math.cos(centerCoordinates.lat * DEGREE_TO_RADIAN) *
        Math.cos(parseFloat(coordinatesArray[coordinate][1]) * DEGREE_TO_RADIAN) *
        (1 - Math.cos((parseFloat(coordinatesArray[coordinate][0]) - centerCoordinates.lng) * DEGREE_TO_RADIAN))) /
      2
    const result = EARTH_DIAMETER * Math.asin(Math.sqrt(hav))
    dataObject[result] = coordinatesArray[coordinate]
  }

  const maxValueInArray = Object.keys(dataObject)
  const maxValue = maxValueInArray.map(function (item) {
    return parseFloat(item)
  })
  return dataObject[Math.max(...maxValue)] // return furthest coordinates from centroid
}

// convert lat long to radian
export const toRad = Value => {
  return (Value * Math.PI) / 180
}

// get distance between centeroid and furthest point in meters
export const farthestDistance = (centroidLat, centroidLong, furthestLat, furthestLong) => {
  const latRadian = toRad(furthestLat - centroidLat)
  const longRadian = toRad(furthestLong - centroidLong)
  centroidLat = toRad(centroidLat)
  furthestLat = toRad(furthestLat)

  // haversine calculations to get distance between centroid and furthest point
  const hav =
    Math.sin(latRadian / 2) * Math.sin(latRadian / 2) +
    Math.sin(longRadian / 2) * Math.sin(longRadian / 2) * Math.cos(centroidLat) * Math.cos(furthestLat)
  const getDistance = 2 * Math.atan2(Math.sqrt(hav), Math.sqrt(1 - hav))
  const finalDistance = RADIUS_OF_EARTH * getDistance
  return finalDistance * 1000 // in meters
}

// get zoom level for map view
export const calcZoom = (visibleDistance, screenSize, atLat) => {
  visibleDistance = Math.abs(visibleDistance)
  const parallelLength = getParallelLength(atLat) // in meters

  // for a screen of 512 pixels
  const zoom512 = Math.log(parallelLength / visibleDistance) / Math.log(2)

  // adapt the zoom to the screen size
  const x = Math.log(screenSize / 512) / Math.log(2)
  return zoom512 + x
}

export const fitBoundsWithPadding = (map, padding) => {
  // Get the current bounds of the map
  const currentBounds = map.getBounds()

  // Calculate the new bounds with padding
  const northEast = currentBounds.getNorthEast()
  const southWest = currentBounds.getSouthWest()

  const newNorthEast = new mapboxgl.LngLat(
    northEast.lng + padding / 2 / map.transform.zoom,
    northEast.lat + padding / 2 / map.transform.zoom
  )
  const newSouthWest = new mapboxgl.LngLat(
    southWest.lng - padding / 2 / map.transform.zoom,
    southWest.lat - padding / 2 / map.transform.zoom
  )

  const paddedBounds = new mapboxgl.LngLatBounds(newSouthWest, newNorthEast)

  // Fit the map to the new bounds with padding
  map.fitBounds(paddedBounds)
}

export const calculateBounds = coordinates => {
  return coordinates.reduce((bounds, coord) => bounds.extend(coord), new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]))
}

export const getFeaturePointFromCoordsObj = ({ latitude, longitude, properties }) => ({
  type: 'Feature',
  geometry: {
    type: 'Point',
    coordinates: [longitude, latitude],
  },
  properties,
})

export const getFeaturePointCollectionFromStops = ({ stops, properties }) => {
  const features = stops.map(({ latitude, longitude, id }) =>
    getFeaturePointFromCoordsObj({ latitude, longitude, properties: { ...properties, id } })
  )
  return {
    type: 'FeatureCollection',
    features,
  }
}

export const addAssetsImageToMap = (map, name, src, sdf = false) => {
  if (!map.hasImage(name)) {
    map.loadImage(src, (error, image) => {
      if (error) throw error
      if (!map.hasImage(name)) map.addImage(name, image, { sdf })
    })
  }
  return null
}

export const mapStopsToCoordinatesArray = stops => stops.map(({ latitude, longitude }) => [longitude, latitude])

export const getFeatureLineStringFromCoordinates = coordinates => {
  return {
    type: 'Feature',
    properties: {},
    geometry: {
      type: 'LineString',
      coordinates,
    },
  }
}

export const getCoordinates = async (location, accessToken) => {
  const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${location}.json?access_token=${accessToken}`
  const response = await fetch(url)
  const data = await response.json()
  return data.features[0].center
}
// taken from: https://github.com/mapbox/mapbox-gl-js/issues/9104#issuecomment-565598143
export const addSourceAsync = (map, sourceId, data, sourceProps, beforeId) => {
  const fixedData = isEmpty(data) ? { type: 'FeatureCollection', features: [] } : data
  return new Promise((resolve, reject) => {
    map.addSource(
      sourceId,
      {
        type: 'geojson',
        data: fixedData,
        ...sourceProps,
      },
      beforeId
    )
    map.getSource(sourceId).once('data', d => {
      resolve(d)
    })
    map.getSource(sourceId).once('error', err => {
      reject(err)
    })
  })
}

const getMinOrMax = (markersObj, minOrMax, latOrLng) => {
  if (minOrMax === 'max') {
    return markersObj.reduce((max, value) => Math.max(max, value[latOrLng]), -Infinity)
  }
  return markersObj.reduce((min, value) => Math.min(min, value[latOrLng]), Infinity)
}

export const getBounds = (markersObj, padding = 0) => {
  const maxLat = getMinOrMax(markersObj, 'max', 1)
  const minLat = getMinOrMax(markersObj, 'min', 1)
  const maxLng = getMinOrMax(markersObj, 'max', 0)
  const minLng = getMinOrMax(markersObj, 'min', 0)

  // Add padding in pixels to the bounding box
  const latPadding = (maxLat - minLat) * (padding / 100)
  const lngPadding = (maxLng - minLng) * (padding / 100)

  // Cap latitude values between -90 and 90
  const cappedMinLat = Math.max(-90, minLat - latPadding)
  const cappedMaxLat = Math.min(90, maxLat + latPadding)

  // Cap longitude values between -180 and 180
  const cappedMinLng = Math.max(-180, minLng - lngPadding)
  const cappedMaxLng = Math.min(180, maxLng + lngPadding)

  const southWest = [cappedMinLng, cappedMinLat]
  const northEast = [cappedMaxLng, cappedMaxLat]

  return [southWest, northEast]
}

/**
 * Calculate bounds for Google Maps from an array of coordinates
 * @param {Array} markersObj - Array of [longitude, latitude] coordinates
 * @param {number} padding - Padding percentage to add around the bounds (0-100)
 * @returns {Object} - Bounds object with south, west, north, east properties for Google Maps
 */
export const getGoogleMapsBounds = (markersObj, padding = 0) => {
  const maxLat = getMinOrMax(markersObj, 'max', 1)
  const minLat = getMinOrMax(markersObj, 'min', 1)
  const maxLng = getMinOrMax(markersObj, 'max', 0)
  const minLng = getMinOrMax(markersObj, 'min', 0)

  // Add padding in pixels to the bounding box
  const latPadding = (maxLat - minLat) * (padding / 100)
  const lngPadding = (maxLng - minLng) * (padding / 100)

  // Cap latitude values between -90 and 90
  const cappedMinLat = Math.max(-90, minLat - latPadding)
  const cappedMaxLat = Math.min(90, maxLat + latPadding)

  // Cap longitude values between -180 and 180
  const cappedMinLng = Math.max(-180, minLng - lngPadding)
  const cappedMaxLng = Math.min(180, maxLng + lngPadding)

  // Return bounds in Google Maps format
  return {
    south: cappedMinLat,
    west: cappedMinLng,
    north: cappedMaxLat,
    east: cappedMaxLng,
  }
}

export const getUniqueStops = (stops, offsetStep = 0.0001) => {
  const coordinatesSet = new Set()

  return stops.map(({ latitude, longitude, ...rest }) => {
    const coordinatesKey = `${latitude}_${longitude}`

    if (coordinatesSet.has(coordinatesKey)) {
      let offset = offsetStep
      while (coordinatesSet.has(`${latitude + offset}_${longitude + offset}`)) {
        offset += offsetStep
      }
      latitude += offset
      longitude += offset
    }

    coordinatesSet.add(coordinatesKey)

    return {
      latitude,
      longitude,
      ...rest,
    }
  })
}

export const getStops = routes => {
  return routes.flatMap(route =>
    route.stops.map(stop => {
      const id = get(stop, 'workOrderId', '')
      const sequence = get(stop, 'sequence', '')
      const color = get(route, 'color', '')
      const workOrderStatus = get(stop, 'workOrderStatus')
      const latitude = get(stop, 'latitude', '')
      const longitude = get(stop, 'longitude', '')
      const routeName = get(route, 'name', '')
      const routeId = get(route, 'id', '')
      return {
        ...stop,
        id,
        sequence,
        latitude,
        longitude,
        routeName,
        color,
        routeId,
        workOrderStatus,
      }
    })
  )
}

export const mapStopsToFeaturePoints = stops =>
  stops.map(({ latitude, longitude, ...rest }, index) => {
    const toBeInserted = get(rest, 'toBeInserted', false)
    const workOrderStatus = stopStatus(rest)
    const marker = get(WORK_ORDER_STATUS_DISPLAY, `${workOrderStatus}.marker`)
    const markerTextColor = get(WORK_ORDER_STATUS_DISPLAY, `${workOrderStatus}.markerTextColor`)
    return getFeaturePointFromCoordsObj({
      latitude,
      longitude,
      properties: {
        latitude,
        longitude,
        ...rest,
        position: index + 1,
        icon: toBeInserted ? 'to-be-assigned-marker' : marker,
        'text-color': toBeInserted ? common.black : markerTextColor,
      },
    })
  })

export const removeSourceIfExist = (map, sourceId) => {
  if (map.getSource(sourceId)) {
    map.removeSource(sourceId)
  }
}

export const removeLayerIfExist = (map, layerId) => {
  if (map.getLayer(layerId)) {
    map.removeLayer(layerId)
  }
}

export const BOTTOM_LAYER = 'BOTTOM_LAYER'
export const MIDDLE_LAYER = 'MIDDLE_LAYER'
export const TOP_LAYER = 'TOP_LAYER'

export const addPositionLayers = map => {
  if (!map || typeof map.getSource !== 'function') {
    return
  }
  if (!map.getSource('empty')) {
    map.addSource('empty', {
      type: 'geojson',
      data: { type: 'FeatureCollection', features: [] },
    })
  }
  // dummy layers to position the other layers
  if (!map.getLayer(TOP_LAYER)) {
    map.addLayer({
      id: TOP_LAYER,
      type: 'symbol',
      source: 'empty',
    })
  }
  if (!map.getLayer(MIDDLE_LAYER)) {
    map.addLayer(
      {
        id: MIDDLE_LAYER,
        type: 'symbol',
        source: 'empty',
      },
      TOP_LAYER
    )
  }
  if (!map.getLayer(BOTTOM_LAYER)) {
    map.addLayer(
      {
        id: BOTTOM_LAYER,
        type: 'symbol',
        source: 'empty',
      },
      MIDDLE_LAYER
    )
  }
}

/**
 * Detects overlapping points and calculates offset coordinates.
 * @param {Array} points - Array of visible marker objects (leaves only, no clusters)
 * @param {number} zoom - Current map zoom level
 * @returns {Object} - Map of ID -> { lat, lng } adjusted coordinates
 */
export const calculateMarkerOffsets = points => {
  const adjustedPoints = {}

  // 1. Group points by proximity
  // LOWERED THRESHOLD: 0.00001 degrees is approx ~1.1 meters.
  // This ensures we only "spiderify" points that are truly overlapping (same building/complex),
  // leaving next-door neighbors (usually >10m apart) as distinct separate pins.
  const THRESHOLD = 0.00001
  const groups = {}

  points.forEach(point => {
    // Handle both raw GeoJSON structure or flattened structure
    const coords = point.geometry ? point.geometry.coordinates : [point.longitude, point.latitude]
    const [lng, lat] = coords

    // Create a spatial key to bucket strictly overlapping points
    const key = `${Math.round(lat / THRESHOLD)}-${Math.round(lng / THRESHOLD)}`

    if (!groups[key]) groups[key] = []
    groups[key].push({ point, lat, lng })
  })

  // 2. Apply offsets to groups containing more than 1 marker
  Object.values(groups).forEach(group => {
    if (group.length <= 1) return

    const count = group.length
    const { lat: centerLat, lng: centerLng } = group[0]

    // Scale radius slightly:
    // 0.000005 deg is ~0.5m. Enough to separate the icons visually without spreading them to the next street.
    const radius = count > 8 ? 0.00001 : 0.000005

    // Distribute points in a perfect circle
    const angleStep = (2 * Math.PI) / count

    group.forEach((item, index) => {
      const angle = index * angleStep

      const latOffset = radius * Math.cos(angle)
      const lngOffset = radius * Math.sin(angle)

      const newLat = centerLat + latOffset
      const newLng = centerLng + lngOffset

      const props = item.point.properties || item.point
      const { id } = props

      if (id) {
        adjustedPoints[id] = { lat: newLat, lng: newLng }
      }
    })
  })

  return adjustedPoints
}
